import React from 'react'
import { styled } from "../../../stitches.config";
import { h3, p, bodyLarge } from '../../commonStyles/Fonts';
import Link from '../../../components/Link';

type JobOfferCardProps = {
    article?: any;
}

const JobOfferCard = ({ article }: JobOfferCardProps) => {

    return (
        <Card>
            <div>
                <p className={p()}>Poszukiwany / Poszukiwana</p>
                <h3 className={h3()}>{article.title}</h3>
                {article.offerWhere &&
                    <>
                        <p className={p()}>Gdzie?</p>
                        <h3 className={h3()}>{article.offerWhere}</h3>
                    </>
                }
            </div>
            <Link to={article.url}>
                <span className={bodyLarge()}>Dowiedz się więcej</span>
            </Link>
        </Card>
    )
}

export default JobOfferCard;

const Card = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    position: 'relative',
    backgroundColor: '$grayscale0Fixed',
    padding: '48px',
    'p, h3': {
        color: '$grayscale100Fixed',
        textAlign: 'left',
    },
    "& a": {
        width: '100%',
        backgroundColor: '$primary',
        color: '$grayscale0Fixed',
        border: 'none',
        height: '48px',
        textAlign: 'center',
        fontSize: '16px',
        lineHeight: '24px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            color: '$grayscale0Fixed',
            textDecoration: "none",
        }
    }
})